import React, { useState } from "react";
import { Container, Row, Col, Form, Card, Button } from "react-bootstrap";
import { auth } from "../firebase";
import { useHistory } from "react-router-dom";

import "../css/ColoredBlock.css";

function SignUp() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const history = useHistory();

  const register = (e) => {
    e.preventDefault();
    auth
      .createUserWithEmailAndPassword(email, password)
      .then(function (response) {
        console.log(response);
        history.push("/storefront");
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  return (
    <Card>
      <br></br>
      <Card.Title className="colored-block__text">Sign Up Now!</Card.Title>
      <Form.Group>
        <br />
        <br />
        <Form.Row>
          <Col className="pl-4 pr-4">
            <Form.Control
              size="lg"
              type="text"
              placeholder="Enter Your Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Col>
        </Form.Row>
        <br />
        <Form.Row>
          <Col className="pl-4 pr-4">
            <Form.Control
              size="lg"
              type="text"
              placeholder="Enter Your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Col>
        </Form.Row>
        <br />
        <Form.Row>
          <Col className="pl-4 pr-4">
            <Form.Control
              size="lg"
              type="password"
              placeholder="Enter Your Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Col>
        </Form.Row>
        <br></br>
        <Button className="colored-block__text" onClick={register}>
          Sign Up
        </Button>
        <br></br>
      </Form.Group>
    </Card>
  );
}

export default SignUp;
